import { Component, Input } from '@angular/core';
import { MaintenanceScheduleTriggerDto } from '@flyfreely-portal-ui/flyfreely';

interface TriggerTypeDisplay {
    label: string;
    /** One of the shared status-block/status-circle colour classes */
    statusClass: 'active' | 'pending' | 'inactive';
}

const TRIGGER_TYPE_DISPLAY: {
    [type in MaintenanceScheduleTriggerDto.Type]: TriggerTypeDisplay | null;
} = {
    NONE: null,
    NOT_DUE: { label: 'Not Due', statusClass: 'active' },
    UPCOMING: { label: 'Upcoming', statusClass: 'pending' },
    DUE: { label: 'Due', statusClass: 'pending' },
    OVERDUE: { label: 'Overdue', statusClass: 'inactive' }
};

/**
 * Shows whether maintenance is triggered on a component, in
 * one of 2 possible layouts:
 * 1. An inline status chip
 * 2. A coloured circle with the status as a tooltip
 */
@Component({
    selector: 'maintenance-trigger-type',
    templateUrl: './maintenance-trigger-type.component.html',
    styleUrl: './maintenance-trigger-type.component.scss'
})
export class MaintenanceTriggerTypeComponent {
    @Input() alwaysShow = false;
    @Input() type?: MaintenanceScheduleTriggerDto.Type;
    @Input() layout: 'INLINE' | 'INDICATOR' = 'INLINE';

    get display(): TriggerTypeDisplay {
        return TRIGGER_TYPE_DISPLAY[this.type ?? 'NONE'];
    }
}
